module.exports = __webpack_public_path__ + "img/honor-right-1-2.ed63b7a9.jpg";